import React from 'react';

import Spinner from '@components/Spinner';
import { useCurrentUser, useUserSettings } from '@hooks';
import { READ_ONLY_MODE, READ_ONLY_PHRASE } from '@src/env';

import SettingsHeading from '../SettingsHeading';
import BasicInfoForm from './BasicInfoForm';
import LinkSection from './LinkSection';

const INITIAL_STATE = {
  name: '',
  email: '',
  password: '',
  passwordConfirmation: '',
};

const Account = () => {
  const { currentUser } = useCurrentUser();
  const { userSettings, isLoadingUserSettings } = useUserSettings();

  return (
    <>
      {isLoadingUserSettings ? (
        <Spinner />
      ) : (
        <div>
          <SettingsHeading title="User Information" />
          {READ_ONLY_MODE && (
            <div className="warning">
              <h3>We&apos;re doing site maintenance now.</h3>
              You can view your settings here, but at the moment you can&apos;t save changes. Please
              refresh this page in {READ_ONLY_PHRASE || '10-15 minutes'}; if this message is gone
              then maintenance is complete.
            </div>
          )}
          <BasicInfoForm
            initialState={{
              ...INITIAL_STATE,
              name: currentUser?.name || '',
              email: currentUser?.email,
            }}
            ReadOnlyMode={READ_ONLY_MODE}
            loginLinkOnly={currentUser?.login_link_only}
          />
          <SettingsHeading title="Account" />
          <LinkSection userSettings={userSettings} />
        </div>
      )}
    </>
  );
};

export default Account;
